import { useContext } from 'react'
import { FrameDetectorContext } from '../contexts/frame-detector'

export function useFrameDetector (): boolean {
  const { frame } = useContext(FrameDetectorContext)
  return frame
}
